import React, { FC } from 'react';
import { NoSSR } from '~/src/helpers/noSSR.helper';
import { useMatchMedia } from '~/src/hooks/use-match-media.hook';
import { MediaWidthEnum } from '~/src/models/enums/media-width.enum';
import { IMAGE_QUALITY } from '~/src/models/constants/image-quality.constants';
import RecommendProductImage from '~/src/images/agency-products/recommend-product.png';
import BackgroundLine from '~/src/images/about-products/background-line.png';
import BackgroundEllipse from '~/src/images/about-products/background-ellipse.png';
import * as Styled from './banner-images.styles';

interface BannerImagesProps {
    isReferralUrl: boolean;
}

export const BannerImages: FC<BannerImagesProps> = ({ isReferralUrl }) => {
    const [isTabletWide] = useMatchMedia(MediaWidthEnum.tabletWide, { withoutSSR: true });

    return (
        <>
            <NoSSR>
                {!isTabletWide && (
                    <Styled.BannerImage
                        width={480}
                        height={316}
                        alt={'Логотип продукта МТС'}
                        src={RecommendProductImage}
                        priority={true}
                        quality={IMAGE_QUALITY.HIGH}
                    />
                )}
            </NoSSR>
            <NoSSR>
                {isTabletWide && (
                    <>
                        <Styled.BackgroundImageLine
                            width={320}
                            height={43}
                            alt={'Фоновое изображение продукта МТС'}
                            src={BackgroundLine}
                            priority={true}
                            quality={IMAGE_QUALITY.HIGH}
                        />
                        <Styled.BackgroundImageEllipse
                            width={320}
                            height={171}
                            alt={'Фоновое изображение продукта МТС'}
                            src={BackgroundEllipse}
                            priority={true}
                            quality={IMAGE_QUALITY.HIGH}
                            isReferralUrl={isReferralUrl}
                        />
                    </>
                )}
            </NoSSR>
        </>
    );
};
